module.exports = __webpack_public_path__ + "static/media/Tier_7.ab86a4b2.png";